import React, { useState } from 'react'
import './videoCard.css'
import {
   AngryIcon,
   EyesIcon,
   HappyIcon,
   LikeIcon,
   LoveIcon,
   SedIcon,
   VideoImage,
   VideoInfoIcon
} from 'assets'
import { useLocation, useNavigate } from 'react-router-dom'
import { createImageUrl } from 'utils/createImageUrl'
import dayjs from 'dayjs'
import { formatNumber } from 'utils/formatNumber'
import { getSentimentIcon } from 'utils/getSentimentIcon'
import { getEmotionIcon } from 'utils/getEmotionIcon'
import { removeUtcFormate } from 'utils/removeUtcFormate'
import { toastError } from 'utils/toastify'
import { useDispatch, useSelector } from 'react-redux'
import { toggleVideoSelection } from 'store/action/videoReducer'
import { videStatusConst } from 'constant/const'

function VideoCard(props) {
   const { items } = props
   const navigate = useNavigate()
   const location = useLocation()
   const [isClicked, setIsClicked] = useState(false)
   const videoReduxData = useSelector((state) => state.videoRedux)
   const { isBatchAnalysisStatus, selectedVideoIds } = videoReduxData
   const dispatch = useDispatch()

   const onRedirect = (type) => {
      if (!isClicked) {
         setIsClicked(true)
         if (items?.comment_count > 0) {
            navigate(`/videos/analysis/${items.video_id}${location?.search}`, {
               state: {
                  loadingMessage:
                     items?.total_analyzed_comments === 0 ? 'Analyzing video, please wait…' : '',
                  type: type
               }
            })
         } else {
            toastError('You don’t have any Youtube comments available for analysis at the moment.')
            setIsClicked(false)
         }
      }
   }

   const handleCheckboxChange = () => {
      dispatch(toggleVideoSelection(items.video_id))
   }

   return (
      <div className="card video-card">
         <div className="video-image-section position-relative">
            <img
               src={items?.thumbnails ? createImageUrl(items?.thumbnails) : VideoImage}
               alt="video"
            />

            {items?.status === videStatusConst.processing ? (
               <div className="video-processing-ui">
                  <div className="video-blur-bg" />
                  <div className="video-processing-message">
                     <div className="loader"></div>
                     <span>Analyzing Video...</span>
                  </div>
               </div>
            ) : (
               !isBatchAnalysisStatus && (
                  <>
                     <div className="video-hover-buttons">
                        <button
                           className="video-btn primary"
                           onClick={() => {
                              items?.is_analyzed ? onRedirect('') : onRedirect('quick')
                           }}>
                           {items?.is_analyzed ? 'View Analysis' : 'Quick Analysis'}
                        </button>
                        <button className="video-btn secondary" onClick={() => onRedirect('full')}>
                           Full Analysis
                        </button>
                     </div>
                  </>
               )
            )}

            {items?.is_analyzed && (
               <div className="video-show-emotion">
                  <div className="d-flex gap-2">
                     {items?.top_emotion?.emotion ? (
                        <div className="text-wrapper" title="Sentiment">
                           <div className="text-wrapper-video-icon">
                              {items?.top_emotion &&
                                 getSentimentIcon(items?.top_emotion?.top_sentiment)}
                           </div>
                           <span className="ms-2 me-2 at-text-dark">{items?.sentiment_score}</span>
                        </div>
                     ) : null}
                     {items?.risk_score && (
                        <div className="text-wrapper" title="Risk">
                           <div className="text-wrapper-video-icon">
                              <VideoInfoIcon />
                           </div>
                           <span className="ms-2 me-2 at-text-dark">{items?.risk_score}</span>
                        </div>
                     )}
                  </div>
                  {items?.top_emotion?.emotion && (
                     <div className="d-flex align-item-center gap-2">
                        <div className="text-wrapper">
                           <div className="text-wrapper-video-icon text-emotion-icon">
                              {getEmotionIcon(
                                 items?.top_emotion?.emotion,
                                 items?.top_emotion?.top_sentiment
                              )}
                           </div>
                           <span className="ms-2 me-1 at-text-dark text-capitalize">
                              {items?.top_emotion?.emotion}
                           </span>
                        </div>
                     </div>
                  )}
               </div>
            )}

            {items?.comment_count > 0 && isBatchAnalysisStatus && (
               <input
                  type="checkbox"
                  className="at-checkbox-video-card form-check-input"
                  checked={selectedVideoIds.includes(items.video_id)}
                  onChange={handleCheckboxChange}
               />
            )}
         </div>

         <div className="video-detail">
            <span className="at-text-light video-date mb-2">
               {items?.published_at
                  ? dayjs(removeUtcFormate(items?.published_at)).format('D MMMM, YYYY')
                  : ''}
            </span>
            <h3 title={items?.title} className="video-name mb-2">
               {items?.title}
            </h3>
            <p className="at-text-light video-comments">
               {items?.comment_count || 0} comments posted ·{' '}
               <span className="video-comments-analysis">
                  {items?.total_analyzed_comments || 0} analyzed
               </span>
            </p>
            <div className="video-icon mt-3">
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <EyesIcon />
                  </div>
                  <span className="at-text-dark video-counter">
                     {formatNumber(items?.video_views || 0, 2)}
                  </span>
               </div>
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <LikeIcon />
                  </div>
                  <span className="at-text-dark video-counter">
                     {formatNumber(items?.video_likes || 0, 2)}
                  </span>
               </div>
            </div>
         </div>
      </div>
   )
}

export default VideoCard
